<div class="asset-periodic-container flex-column d-flex">
  <div class="header mb-4">
    <div>
      <a class="d-inline-block" [routerLink]="['/asset-management/compliance-overview']" [queryParams]="{ tab: 'periodicComplianceTasks' }">
				<h2 class="d-flex align-items-center gap-2 m-0 h3">
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
						<path
							d="M20.9999 11H6.41394L11.7069 5.70697L10.2929 4.29297L2.58594 12L10.2929 19.707L11.7069 18.293L6.41394 13H20.9999V11Z"
							fill="#9FA1A4" />
					</svg>
          <span class="title m-0">{{ assetName }}</span>
				</h2>
      </a>
    </div>
  </div>

  <div class="row mb-2">
    @if (assetId && complianceId) {
      <div class="col-lg-3 col-md-6 col-sm-12">
        <app-pass-widget [assetId]="assetId" [complianceId]="complianceId" [taskId]="taskId" source="periodic"></app-pass-widget>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <app-fail-widget [assetId]="assetId" [complianceId]="complianceId" [taskId]="taskId" source="periodic"></app-fail-widget>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <app-pending-widget [assetId]="assetId" [complianceId]="complianceId" [taskId]="taskId" source="periodic"></app-pending-widget>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <app-inspection-pass-rate-widget [assetId]="assetId" [complianceId]="complianceId" [taskId]="taskId" source="periodic"></app-inspection-pass-rate-widget>
      </div>
    }
  </div>

  <div>
    <app-compliance-tasks
      [columns]="columns"
      [data]="assetComplianceTasks"
      [isLoading]="isLoading"
      [isLoadingMore]="isLoadingMore"
      [hasError]="hasError"
      [isComplianceTasks]="true"
      [minWidth]="1100"
      (rowClicked)="onRowClick($event)"
      (scrolledDown)="onScrollDown()">
    </app-compliance-tasks>
  </div>
</div>